import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import { buildGetCardApiConfig, buildEditCardApiConfig } from '../cards.api';
import { CardRouterOrigin } from './card-selected.types';

export const SET_CARD_SELECTED = '@card/selected-card/SET_CARD_SELECTED';
export const UPDATED_CARD_SELECTED = '@card/selected-card/UPDATED_CARD_SELECTED';
export const UPDATE_CARD_MODAL_CUSTOM_DATA = '@card/selected-card/UPDATE_CARD_MODAL_CUSTOM_DATA';
export const SET_IS_CARD_VALID = '@card/selected-card/SET_IS_CARD_VALID';

export const GET_CARD_REQUEST_CALLED = '@card/selected-card/GET_CARD_REQUEST_CALLED';
export const GET_CARD_REQUEST_SUCCEEDED = '@card/selected-card/GET_CARD_REQUEST_SUCCEEDED';
export const GET_CARD_REQUEST_FAILED = '@card/selected-card/GET_CARD_REQUEST_FAILED';

export const EDIT_CARD_REQUEST_CALLED = '@card/selected-card/EDIT_CARD_REQUEST_CALLED';
export const EDIT_CARD_REQUEST_SUCCEEDED = '@card/selected-card/EDIT_CARD_REQUEST_SUCCEEDED';
export const EDIT_CARD_REQUEST_FAILED = '@card/selected-card/EDIT_CARD_REQUEST_FAILED';

export const getCardLoadingState = state => state.cards.cardSelected.loadState;
export const getCardSelected = state => state.cards.cardSelected.data;
export const isCardModified = state => state.cards.cardSelected.cardFieldsModified;
export const getCardOriginRouter = state => state.cards.cardSelected.originRoute;
export const getIsCardValid = state => state.cards.cardSelected.isCardValid;

export const setCardSelected = ({
    card,
    cardFieldsModified = false,
    originRoute = CardRouterOrigin.WORKFLOW,
    isCardValid = false,
}) => ({
    type: SET_CARD_SELECTED,
    payload: {
        card, cardFieldsModified, originRoute, isCardValid,
    },
});

export const getCard = ({ cardId }) => ({
    type: GET_CARD_REQUEST_CALLED,
    actionTypes: {
        success: GET_CARD_REQUEST_SUCCEEDED,
        fail: GET_CARD_REQUEST_FAILED,
    },
    config: buildGetCardApiConfig({ cardId }),
});

export const updateCardSelected = ({ card }) => ({
    type: UPDATED_CARD_SELECTED,
    payload: {
        card,
    },
});

export const updateCardModalCustomData = (customData, options = { isCardModified: true }) => ({
    type: UPDATE_CARD_MODAL_CUSTOM_DATA,
    payload: { customData, options },
});

export const updateCardRequest = card => ({
    type: EDIT_CARD_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_CARD_REQUEST_SUCCEEDED,
        fail: EDIT_CARD_REQUEST_FAILED,
    },
    config: buildEditCardApiConfig({ card }),
});

export const setIsCardValid = ({ isCardValid }) => ({
    type: SET_IS_CARD_VALID,
    payload: { isCardValid },
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: null,
    error: null,
    cardFieldsModified: false,
    originRoute: CardRouterOrigin.EXTERNAL_LINK,
    isCardValid: false,
};

export const cardSelectedReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_CARD_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [GET_CARD_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: {
            ...action.payload.data,
            custom_data: JSON.parse(action.payload.data.custom_data),
        },
        loadState: LOAD_STATE.SUCCESS,
        originRoute: CardRouterOrigin.EXTERNAL_LINK,
        error: null,
    }),
    [GET_CARD_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: initialState.data,
        loadState: LOAD_STATE.FAIL,
        error: action.payload.response,
    }),
    [SET_CARD_SELECTED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.card,
        cardFieldsModified: action.payload.cardFieldsModified,
        originRoute: action.payload.originRoute,
        isCardValid: action.payload.isCardValid,
    }),

    [SET_IS_CARD_VALID]: (state, action) => ({
        ...state,
        isCardValid: action.payload.isCardValid,
    }),

    [UPDATED_CARD_SELECTED]: (state, action) => {
        const { data: cardSelected, cardFieldsModified: cardAlreadyModified } = state;

        const cardFieldsModified = JSON.stringify(cardSelected)
        !== JSON.stringify(action.payload.card);

        return {
            ...state,
            cardFieldsModified: cardAlreadyModified || cardFieldsModified,
            data: {
                ...state.data,
                ...action.payload.card,
            },
        };
    },
    [UPDATE_CARD_MODAL_CUSTOM_DATA]: (state, action) => ({
        ...state,
        cardFieldsModified: action.payload.options.isCardModified,
        data: {
            ...state.data,
            custom_data: {
                ...state.data.custom_data,
                ...action.payload.customData,
            },
        },
    }),
});
